/**
 * Confirm delete dropdown pattern
 *
 * First click: replaces content with "Confirm delete" text.
 * Second click: fires htmx 'confirmed' event and resets.
 * Clicking elsewhere resets without deleting.
 */

(function () {

    // While its tooltip shows, tooltip.js moves `title` into data-tooltip-text
    // and puts it back on mouseout. The arming click always lands on hover, so
    // the label is read from and written to wherever it currently lives, and
    // the visible tooltip follows.
    function getLabel(trigger, attr) {
        if (attr === 'title' && 'tooltipText' in trigger.dataset) return trigger.dataset.tooltipText;
        return trigger.getAttribute(attr);
    }

    function setLabel(trigger, attr, value) {
        if (attr === 'title' && 'tooltipText' in trigger.dataset) {
            trigger.dataset.tooltipText = value;
            var tip = document.querySelector('body > .tooltip');
            if (tip) tip.textContent = value;
            return;
        }
        if (value) trigger.setAttribute(attr, value);
        else trigger.removeAttribute(attr);
    }

    function reset(trigger) {
        trigger.innerHTML = trigger.getAttribute('data-confirm-original');
        trigger.removeAttribute('data-confirm-armed');
        trigger.removeAttribute('data-confirm-original');
        ['title', 'aria-label'].forEach(function (attr) {
            var saved = 'data-confirm-saved-' + attr;
            if (!trigger.hasAttribute(saved)) return;
            setLabel(trigger, attr, trigger.getAttribute(saved));
            trigger.removeAttribute(saved);
        });
        if (trigger._confirmOutsideClick) {
            document.removeEventListener('click', trigger._confirmOutsideClick, true);
            delete trigger._confirmOutsideClick;
        }
    }

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-confirm-delete]');
        if (!trigger) return;

        e.preventDefault();
        e.stopPropagation();

        // Second click — armed, fire confirmed
        if (trigger.hasAttribute('data-confirm-armed')) {
            reset(trigger);
            if (window.htmx) htmx.trigger(trigger, 'confirmed');
            return;
        }

        // First click — arm it
        trigger.setAttribute('data-confirm-armed', '');
        trigger.setAttribute('data-confirm-original', trigger.innerHTML);
        var label = trigger.getAttribute('data-confirm-label') || 'Confirm delete';
        var icon = trigger.getAttribute('data-confirm-icon') || 'fa-solid fa-trash';
        if (trigger.matches('.btn-icon, .photo-grid__remove')) {
            // Icon-only: keep the fixed footprint so the row doesn't shift;
            // the confirm text moves to the tooltip and accessible name
            ['title', 'aria-label'].forEach(function (attr) {
                trigger.setAttribute('data-confirm-saved-' + attr, getLabel(trigger, attr) || '');
                setLabel(trigger, attr, label);
            });
            trigger.innerHTML = '<i class="' + icon + '"></i>';
        } else {
            trigger.innerHTML = '<i class="' + icon + '"></i> ' + label;
        }

        // Reset if user clicks elsewhere
        trigger._confirmOutsideClick = function (ev) {
            if (ev.target.closest('[data-confirm-armed]') === trigger) return;
            reset(trigger);
        };
        setTimeout(function () {
            document.addEventListener('click', trigger._confirmOutsideClick, true);
        }, 0);
    }, true);

})();
